<template>
    <div class="venue">
        <address>
            <h6 class="subtitle">Venue</h6>
            <span>{{ location.name }}</span>, <span v-if="location.country_code">{{ location.country.name }} </span><br/>
            <!-- <span><strong>{{ location.name }}, &nbsp;</strong></span><span>{{ location.street_address }}</span><br/> -->
            <!-- <span>{{ location.postcode }}</span> -->
        </address>
        <basic-google-map :markers="location"></basic-google-map>
    </div>
</template>

<script>
import BasicGoogleMap from '@/components/global/BasicGoogleMap';

export default {
    name: 'venue-card',

    components: {
        BasicGoogleMap
    },

    props: {
        title: {
            type: String,
            default: ''
        },

        location: {
            type: Object,
            default() {
                return {};
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    .venue {
        position: relative;
        margin-top: 35px;
        margin-bottom: 70px;
        address {
            position: absolute;
            left: 0;
            bottom: -16px;
            z-index: 1;
            padding: 15px 20px;
            background-color: rgba(0, 1, 18, 0.88);
            color: #ffffff;
            display: inline-block;
            width: 100%;
            font-size: 15px;

            @include media-breakpoint-up(lg) {
                width: 320px;
                padding: 25px 30px;
            }

            h6 {
                margin-bottom: 8px;
                @include media-breakpoint-up(lg) {
                    margin-bottom: 24px;
                }
            }
            span {
                line-height: 25px;
            }
        }
    }
</style>
